export default "__VITE_ASSET__CbkFZ$ag__"